export const forbids_body = ['GET', 'HEAD'];
export const status_empty = [101, 204, 205, 304];
export const status_cache = [304];
export const status_redirect = [300, 301, 302, 303, 304, 305, 306, 307, 308];
